@if (updateSuccess) {
  <div class="alert alert-success">
    {{'CONF_SAVED' |translate}}
  </div>
}
@if (updateError) {
  <div class="alert alert-danger">
    {{'ERROR' |translate}}
  </div>
}

@if (iotCommsConfigurationLoaded) {
  <form [formGroup]="iotCommsForm" (ngSubmit)="formSubmitSubject.next()">
    <mat-slide-toggle class="pb-4" (change)="updateScaipDependentValidators()" formControlName="scaipEnabled">
      <strong>SCAIP</strong>
    </mat-slide-toggle>
    <div class="form-group">
      <label><strong>{{'CONFIG_TYPE' |translate}}</strong></label>
      <select id="config-type-selector" class="form-control" formControlName="configType">
        <option [value]="''">{{ "DEFAULT" | translate }}</option>
        <option value="Jontek">Jontek</option>
        <option value="Enovation">Enovation/Tunstall</option>
        <option value="Sky Response">Sky Response</option>
        <option value="Appello">Appello</option>
      </select>
    </div>
    @if (!scaipEnabled) {
      <div class="form-group">
        <label><strong>{{'ARC_DESTINATION_NUMBER' |translate}}</strong></label>
        <input class="form-control" type="text" formControlName="destination">
      </div>
    }
    @if (!scaipEnabled) {
      <div class="form-group">
        <label><strong>{{'ARC_DESTINATION_DOMAIN' |translate}}</strong></label>
        <p>{{'ARC_DESTINATION_DOMAIN_HELP' |translate}}</p>
        <input class="form-control" type="text" formControlName="domain">
      </div>
    }
    @if (scaipEnabled) {
      <div class="form-group">
        <label><strong>{{'ARC_NAME' |translate}}</strong></label>
        <input class="form-control" type="text" formControlName="arcName">
      </div>
      <div class="form-group">
        <label><strong>{{'ARC_NUMBER' |translate}}</strong></label>
        <input class="form-control" type="text" formControlName="arcNumber">
      </div>
    }
    <div class="form-group">
      <label><strong>{{'SCHEME_ID' |translate}}</strong></label>
      <input class="form-control" type="text" formControlName="schemeId">
    </div>
    <div class="form-group">
      <label><strong>Audio</strong></label>
      <input class="form-control" type="text" formControlName="audio">
    </div>
    <div class="form-group">
      <label><strong>{{'RETRY_TIME' |translate}}</strong></label>
      <input class="form-control" type="text" formControlName="retryTime">
    </div>
    @if (scaipEnabled) {
      <h6 id="SCAIP-header">
        <strong>SCAIP {{ "SETTINGS" | translate }}</strong>
      </h6>
      <hr class="mt-0 mb-3" />
      <div class="form-group mt-4">
        <label><strong>{{ "EVENT_RECEIVER" | translate }}</strong></label>
        <input class="form-control" type="text" formControlName="eventReceiver">
      </div>
      <div class="form-group">
        <label><strong>{{ "CALLBACK_SIP" | translate }}</strong></label>
        <input class="form-control" type="text" formControlName="callbackSIP">
      </div>
    }
    <div class="form-group mb-1 mt-2">
      <button [disabled]="(iotCommsForm.invalid || iotCommsForm.pristine)" type="submit" class="btn btn-outline-primary mr-1"><span class="fa-light fa-floppy-disk"></span> {{'SAVE' |translate}}</button>
      <span class="btn btn-primary float-right" (click)="syncToIotCOmms()"><span class="fal fa-rotate"></span> {{'SYNC_TO_IOTCOMMS' |translate}}</span>
    </div>
    @if (provisionDone) {
      <div class="form-group alert alert-info">
        {{'PROVISION_COMPLETED' |translate}}, {{'SUCCESS' |translate}}: {{provisionSuccess}} - {{'FAILED' |translate}}: {{provisionFailed}}
      </div>
    }
  </form>
}
